// extracted by mini-css-extract-plugin
export var dividerLine = "_5t-3";
export var itemImage = "_5t-9";
export var lightDivider = "_5t-4";
export var modalContent = "_5t-5";
export var modalContentCompact = "_5t-6";
export var productCard = "_5t-a";
export var productImage = "_5t-b";
export var productImageCompact = "_5t-7";
export var productImagePlaceholder = "_5t-c";
export var productImagePlaceholderCompact = "_5t-8";
export var progressBarBackground = "_5t-1";
export var progressBarContainer = "_5t-0";
export var progressBarFill = "_5t-2";